import { render, staticRenderFns } from "./guardianfrom.vue?vue&type=template&id=415bf952&"
import script from "./guardianfrom.vue?vue&type=script&lang=js&"
export * from "./guardianfrom.vue?vue&type=script&lang=js&"
import style0 from "./guardianfrom.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports